var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"show":_vm.open,"small":false,"identifier":"preview-menu"},on:{"close":_vm.close},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('PDF',{attrs:{"fromModal":true},on:{"close":_vm.close}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }